export type CanonicalEnvironment = 'dev' | 'stage' | 'prod';

export interface ChronologIngestionConfig {
	endpoint: string;
	token: string;
	environment: CanonicalEnvironment;
}

export function getChronologIngestionConfig(): ChronologIngestionConfig | null {
	const endpoint = import.meta.env.VITE_CHRONOLOG_INGESTION_URL?.trim();
	const token = import.meta.env.VITE_CHRONOLOG_INGESTION_TOKEN?.trim();
	const environment = canonicalEnvironment(import.meta.env.VITE_ENV);
	if (!endpoint || !token || !environment) return null;
	return { endpoint, token, environment };
}

function canonicalEnvironment(value?: string): CanonicalEnvironment | null {
	switch (value?.trim().toLowerCase()) {
		case 'dev':
		case 'development':
			return 'dev';
		case 'stage':
		case 'staging':
			return 'stage';
		case 'prod':
		case 'production':
			return 'prod';
		default:
			return null;
	}
}
